const translations = {
  fr: {
    campaign: {
      purchasedCampaignPageTitle: 'Campagnes achetées',
      purchasedCampaigns: 'Campagnes achetées',
      allCampaigns: 'Toutes les campagnes',
      seeCampaignsButton: 'Voir les campagnes achetées',
      spotsBought: 'Spot acheté',
      spotsBought_plural: 'Spots achetés',
      unavailableCampaigns: 'Les campagnes ne sont pas disponibles',
    },
  },
  en: {
    campaign: {
      purchasedCampaignPageTitle: 'Purchased Campaigns',
      purchasedCampaigns: 'Purchased campaigns',
      allCampaigns: 'All campaigns',
      seeCampaignsButton: 'See purchased campaigns',
      spotsBought: 'Spot Bought',
      spotsBought_plural: 'Spots Bought',
      unavailableCampaigns: 'Campaigns are unavailable',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/advertisers/modules/campaign/i18n/campaign.js